import "core-js/modules/es.number.constructor.js";
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  name: 'AddToCartOverlay',
  components: {
    AzImg: AzImg,
    AzButton: AzButton,
    PriceDisplay: PriceDisplay,
    AzIcon: AzIcon
  },
  props: {
    items: {
      type: Object
    },
    image: {
      type: String
    },
    price: {
      type: Object
    },
    title: {
      type: String
    },
    productType: {
      type: String,
      default: 'product'
    },
    variant: {
      type: String
    },
    quantity: {
      type: Number
    },
    defaultImage: {
      type: String,
      default: ''
    }
  },
  setup: function setup() {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    return {
      locale: locale,
      translate: translate
    };
  }
});